import type { TranslationModule } from '../types';

export const prezentareTranslations: TranslationModule = {
  ro: {
    seoTitle: "LegeaAplicată | Platformă de Cercetare și Analiză Juridică cu AI",
    seoDesc: "Descoperă ecosistemul LegeaAplicată pentru cercetare juridică, jurisprudență, legislație, management de dosare și instrumente profesionale asistate de AI.",
    aiTitle: "Inteligență Artificială",
    aiSubtitle: "în Slujba Justiției",
    mainDesc: "Legea Aplicată nu este doar un soft legislativ. Este un ecosistem complet care integrează legislația, doctrina și jurisprudența cu puterea de analiză a Inteligenței Artificiale.",
    founderTitle: "Fondator LegeaAplicata.ro",
    founderQuote: "\"Justiția modernă necesită o înțelegere profundă a două lumi: rigoarea legii și precizia tehnologiei.\"",
    expertTitle: "Pregătire Juridică",
    expertDesc: "Studii în științe juridice aplicate în dezvoltarea de arhitecturi de indexare, clasificare și căutare a informației legislative.",
    softwareTitle: "Inginerie Software",
    softwareDesc: "Competențe avansate în informatică aplicate pentru a digitaliza și eficientiza procesele juridice.",
    whyUs: "De ce LegeaAplicata.ro?",
    legalIntelTitle: "Legal Intelligence",
    legalIntelDesc: "Combinăm analiza datelor publice cu puterea algoritmilor de căutare pentru a facilita accesul rapid la hotărâri, legi și repere doctrinare.",
    trustTitle: "Profesionalism și Încredere",
    trustDesc: "Fiecare funcționalitate a platformei este gândită pentru cercetare și documentare, fără a oferi consultanță juridică și fără a substitui asistența unui avocat autorizat.",
    founderMission: "\"Misiunea noastră este să facilităm documentarea juridică prin tehnologie. LegeaAplicata.ro este o platformă software de cercetare informațională dedicată eficientizării accesului la date.\"",
    roadmapTitle: "Roadmap de Inovație",
    evolutionTitle: "Evoluție Continuă",
    evolutionDesc: "Un angajament ferm pentru performanță: lansăm constant noi funcționalități care transformă modul în care lucrezi.",
    watchVideo: "Vezi Prezentarea",
    videoError: "Browser-ul tău nu suportă redarea video.",
    videoUrl: "/assets/prezentare/timeline_video_full.mp4",
    videoMobileUrl: "/assets/prezentare/timeline_mobile_full.mp4",
    contactMe: "Contactează-mă",
    readyForFuture: "Pregătit pentru viitor?",
    tryFreeToday: "Începe Gratuit Astăzi",
    timeline: {
      perspective: {
        title: "Perspective Juridice",
        description: "Extrage automat și structurează argumentele instanței, analizele judecătorului și doctrina aplicabilă din mii de hotărâri judecătorești. Include filtrare instantanee după materie și obiect semantic.",
        date: "21 Februarie 2026"
      },
      a: {
        title: "Ecosistemul Juridic Integrat",
        description: "O platformă unificată ce digitalizează cercetarea jurisprudențială. Punem puterea tehnologiei în sprijinul documentării juridice rapide și structurate.",
        date: "10 Ianuarie 2026"
      },
      b: {
        title: "Bibliotecă Juridică Digitală",
        description: "Acces gratuit și instantaneu la legislația actualizată și o bază vastă de modele de documente. Folosește motorul nostru de căutare semantică pentru a găsi rapid exact formularul sau legea de care ai nevoie.",
        date: "15 Decembrie 2025"
      },
      c: {
        title: "Bibliotecă Vastă de Modele Validate",
        description: "Accesează sute de modele de acte procedurale gata de utilizare. De la întâmpinări la cereri de chemare în judecată, baza noastră de date acoperă o gamă largă de spețe civile și penale, verificate din punct de vedere procedural.",
        date: "28 Noiembrie 2025"
      },
      d: {
        title: "Modele Standardizate și Actualizate",
        description: "Redactezi cu încredere. Fiecare model de document respectă riguros normele de procedură și uzanțele instanțelor, având o structură clară și conținut validat juridic.",
        date: "12 Noiembrie 2025"
      },
      e: {
        title: "Toate Codurile într-un Singur Loc",
        description: "Navighează fără efort prin întreaga legislație a României. Motorul nostru îți afișează simultan articole relevante din Codul Civil, Penal sau de Procedură, oferindu-ți o perspectivă completă asupra oricărei instituții de drept.",
        date: "25 Octombrie 2025"
      },
      f: {
        title: "Doctrină și Comentarii Relevante",
        description: "Transformă textul de lege în documentare clară. Ai acces direct la extrase din doctrină și comentarii atașate articolelor de lege, economisind ore întregi de căutare.",
        date: "10 Octombrie 2025"
      },
      g: {
        title: "Analiză Juridică Augmentată",
        description: "Obține un avantaj strategic. Prin combinarea explicațiilor generate de AI cu accesul la hotărâri judecătorești reale, îți construiești argumentația pe o bază informațională solidă și completă.",
        date: "22 Septembrie 2025"
      },
      h: {
        title: "Analiză Instantă a Situației de Fapt",
        description: "Introdu descrierea completă a cazului tău. Sistemul analizează automat contextul (părți, obiect, cauză) și identifică rapid precedentul judiciar și modelele de cereri aplicabile situației tale specifice.",
        date: "05 Septembrie 2025"
      },
      i: {
        title: "Pregătire și Auto-evaluare",
        description: "Transformă studiul jurisprudenței în antrenament activ. Platforma poate genera automat teste grilă din spețele identificate, ajutându-te să îți verifici cunoștințele și să te pregătești eficient pentru examene.",
        date: "18 August 2025"
      },
      j: {
        title: "Navigare în Profunzime",
        description: "Explorează fiecare fațetă a deciziei. Folosește meniul lateral inteligent pentru a sări direct la secțiunea care te interesează: vezi situația de fapt, analizează hotărârea finală sau accesează modelele și codurile asociate.",
        date: "02 August 2025"
      },
      k: {
        title: "Extragerea Automată a Situației de Fapt",
        description: "Înțelege povestea din spatele dosarului. Platforma separă automat contextul faptic de argumentele juridice tehnice, permițându-ți să parcurgi rapid istoricul litigiului fără a te pierde în detalii procedurale.",
        date: "15 Iulie 2025"
      },
      l: {
        title: "Învață din Argumentele Instanței",
        description: "Perfecționează-ți strategia. Analizând modul în care judecătorul a validat sau respins susținerile părților, poți construi apărări mai solide și anticipa mai bine reacția instanței în propriile tale dosare.",
        date: "28 Iunie 2025"
      },
      m: {
        title: "Căutare în Textul Hotărârii",
        description: "Nu pierde timpul citind zeci de pagini irelevante. Folosește motorul de căutare intern pentru a localiza instantaneu cuvinte cheie, nume sau articole de lege direct în corpul textului hotărârii judecătorești.",
        date: "12 Iunie 2025"
      },
      n: {
        title: "Lecția Juridică Decriptată",
        description: "Nu reține doar soluția, ci și principiul. Secțiunea \"Ce învățăm din această speță?\" extrage esența teoretică a deciziei, transformând fiecare caz parcurs într-o lecție de drept aplicat.",
        date: "25 Mai 2025"
      },
      o: {
        title: "Modele Sugerate Contextual",
        description: "Nu mai căuta acul în carul cu fân. Platforma identifică natura juridică a dosarului și îți pune la dispoziție automat lista modelelor de cereri și acte procedurale perfect aplicabile tipului de litigiu analizat.",
        date: "08 Mai 2025"
      },
      p: {
        title: "Legătura Directă cu Legea",
        description: "Nu mai căuta articolele manual. Platforma creează o punte directă între jurisprudență și legislație, afișând automat normele juridice incidente pentru ca tu să înțelegi rapid baza legală a soluției.",
        date: "15 Aprilie 2025"
      },
      q: {
        title: "Calcul Automat al Taxelor",
        description: "Scapă de incertitudinea costurilor. Sistemul recunoaște tipul cererii din speță (ex: contestație la executare) și pre-completează calculatorul cu parametrii corecți, oferindu-ți instantaneu o estimare precisă a taxei judiciare de timbru.",
        date: "20 Martie 2025"
      },
      r: {
        title: "Predicție și Strategie AI",
        description: "Anticipează rezultatul dosarului tău. Algoritmii noștri analizează mii de cazuri similare pentru a-ți estima șansele de succes, durata procesului și argumentele câștigătoare, transformând incertitudinea în strategie calculată.",
        date: "10 Februarie 2025"
      },
      s: {
        title: "Biblioteca Ta de Cunoștințe",
        description: "Mai mult decât un instrument, o resursă de creștere. Accesează o arhivă vastă de peste 1600 de articole și analize, transformând platforma în partenerul tău principal pentru cercetare și perfecționare continuă.",
        date: "15 Ianuarie 2025"
      },
      t: {
        title: "Căutare după Număr de Dosar",
        description: "Pornește direct de la dosarul tău. Introduci numărul de înregistrare, iar platforma identifică automat materia și obiectul cauzei, generând instantaneu o listă de spețe similare relevante.",
        date: "21 Mai 2024"
      }
    }
  },
  en: {
    seoTitle: "LegeaAplicată | Legal Research and AI Analysis Platform",
    seoDesc: "Discover the LegeaAplicată ecosystem for legal research, jurisprudence, legislation, case management, and professional tools assisted by AI.",
    aiTitle: "Artificial Intelligence",
    aiSubtitle: "at the Service of Justice",
    mainDesc: "Legea Aplicată is not simply a legislative database. It is a complete ecosystem that integrates legislation, legal doctrine, and jurisprudence with the analytical power of Artificial Intelligence.",
    founderTitle: "Founder of LegeaAplicata.ro",
    founderQuote: "\"Modern justice requires a deep understanding of two worlds: the rigour of the law and the precision of technology.\"",
    expertTitle: "Legal Background",
    expertDesc: "Studies in legal sciences applied to developing architectures for indexing, classifying, and searching legislative information.",
    softwareTitle: "Software Engineering",
    softwareDesc: "Advanced computer science skills applied to digitize, streamline, and optimize legal processes.",
    whyUs: "Why LegeaAplicata.ro?",
    legalIntelTitle: "Legal Intelligence",
    legalIntelDesc: "We combine public data analysis with search algorithms to facilitate fast access to decisions, statutes, and doctrine references.",
    trustTitle: "Professionalism and Trust",
    trustDesc: "Every feature of the platform is designed for research and documentation, without providing legal consultation and without substituting a licensed attorney.",
    founderMission: "\"Our mission is to facilitate legal documentation through technology. LegeaAplicata.ro is an information research software platform dedicated to efficient data access.\"",
    roadmapTitle: "Innovation Roadmap",
    evolutionTitle: "Continuous Evolution",
    evolutionDesc: "A steadfast commitment to performance: we constantly deploy new features that redefine the way you work.",
    watchVideo: "Watch Presentation",
    videoError: "Your browser does not support HTML5 video playback.",
    videoUrl: "/assets/prezentare/timeline_video_full.mp4",
    videoMobileUrl: "/assets/prezentare/timeline_mobile_full.mp4",
    contactMe: "Contact Me",
    readyForFuture: "Ready for the future?",
    tryFreeToday: "Start Free Today",
    timeline: {
      perspective: {
        title: "Legal Perspectives",
        description: "Automatically extracts and structures court arguments, judicial analysis, and applicable doctrine from thousands of court decisions. Features real-time filtering by legal domain and semantic subject-matter.",
        date: "February 21, 2026"
      },
      a: {
        title: "Integrated Legal Ecosystem",
        description: "A unified platform modernizing case law research, bringing technology to assist fast, structured legal documentation.",
        date: "January 10, 2026"
      },
      b: {
        title: "Digital Legal Library",
        description: "Free, instant access to up-to-date legislation and a comprehensive library of document templates. Utilize our semantic search engine to find the exact form or law you need in seconds.",
        date: "December 15, 2025"
      },
      c: {
        title: "Extensive Library of Validated Templates",
        description: "Access hundreds of ready-to-use procedural document templates. From statements of defense to initial complaints, our database covers civil and criminal practice with procedural validation.",
        date: "November 28, 2025"
      },
      d: {
        title: "Standardized and Up-to-Date Templates",
        description: "Draft with confidence. Every document template rigorously complies with procedural rules and court practices, featuring a clear structure and legally validated content.",
        date: "November 12, 2025"
      },
      e: {
        title: "All Codes in One Place",
        description: "Effortlessly navigate Romania's complete statutory codes. Our search engine simultaneously displays relevant articles from the Civil Code, Criminal Code, and Procedural Codes, providing a comprehensive view of any legal institution.",
        date: "October 25, 2025"
      },
      f: {
        title: "Doctrine and Commentary",
        description: "Gain direct access to relevant doctrine and court commentaries attached to each article, saving hours of manual research.",
        date: "October 10, 2025"
      },
      g: {
        title: "Augmented Legal Analysis",
        description: "Gain a strategic advantage. By combining AI-generated explanations with access to real court judgments, you can build your case arguments on a robust and complete information foundation.",
        date: "September 22, 2025"
      },
      h: {
        title: "Instant Factual Analysis",
        description: "Input the full factual details of your case. The system automatically analyzes the context (parties, object, cause) and quickly identifies the relevant judicial precedents and procedural forms.",
        date: "September 5, 2025"
      },
      i: {
        title: "Preparation and Self-Assessment",
        description: "Turn case-law study into active practice. The platform can automatically generate multiple-choice quizzes from identified cases, helping you test your knowledge and prepare effectively for exams.",
        date: "August 18, 2025"
      },
      j: {
        title: "Deep Navigation",
        description: "Explore every facet of a decision. Use the smart sidebar to jump directly to sections of interest: examine the factual background, analyze the final ruling, or access associated templates and codes.",
        date: "August 2, 2025"
      },
      k: {
        title: "Automatic Extraction of Factual Background",
        description: "Understand the story behind the file. The platform separates the factual background from technical legal arguments, allowing you to quickly review case history without getting lost in procedural details.",
        date: "July 15, 2025"
      },
      l: {
        title: "Learn from Court Arguments",
        description: "Refine your strategy. By analyzing how the judge validated or dismissed the arguments of the parties, you can build stronger cases and better anticipate court responses in your own practice.",
        date: "June 28, 2025"
      },
      m: {
        title: "Search within Judicial Decisions",
        description: "Save time by avoiding dozens of irrelevant pages. Use the internal search engine to instantly locate keywords, names, or legal articles directly within the text of the court judgment.",
        date: "June 12, 2025"
      },
      n: {
        title: "Decrypted Legal Lessons",
        description: "Go beyond the mere ruling to understand the underlying legal principle. The 'What we learn from this case' section extracts the theoretical core of the decision, turning each case into an applied law lesson.",
        date: "May 25, 2025"
      },
      o: {
        title: "Contextually Suggested Templates",
        description: "Stop searching for a needle in a haystack. The platform identifies the legal nature of the case and automatically provides a list of procedural forms and templates perfectly suited for the litigation.",
        date: "May 8, 2025"
      },
      p: {
        title: "Direct Link to Legislation",
        description: "No more manual article lookups. The platform bridges jurisprudence and statutory law, automatically displaying the applicable legal provisions so you can quickly grasp the legal basis of the decision.",
        date: "April 15, 2025"
      },
      q: {
        title: "Automatic Court Fee Calculation",
        description: "Eliminate pricing uncertainty. The system recognizes the type of claim (e.g., foreclosure challenge) and pre-fills the calculator with the correct parameters, giving you an instant estimate of the judicial stamp tax.",
        date: "March 20, 2025"
      },
      r: {
        title: "AI Prediction and Strategy",
        description: "Anticipate the outcome of your case. Our algorithms analyze thousands of similar cases to estimate success rates, trial duration, and winning arguments, turning uncertainty into a calculated strategy.",
        date: "February 10, 2025"
      },
      s: {
        title: "Your Knowledge Library",
        description: "More than just a tool, it's a growth resource. Access a vast archive of over 1,600 articles and legal analyses, turning the platform into your primary partner for research and continuous professional development.",
        date: "January 15, 2025"
      },
      t: {
        title: "Search by Case File Number",
        description: "Start directly from your own case. Enter the registry number, and the platform automatically identifies the field and subject-matter of the case, generating an instant list of similar relevant precedents.",
        date: "May 21, 2024"
      }
    }
  },
  fr: {
    seoTitle: "LegeaAplicată | Plateforme de Recherche et d'Analyse Juridique par IA",
    seoDesc: "Découvrez l'écosystème LegeaAplicată pour la recherche juridique, la jurisprudence, la législation, la gestion des dossiers et les outils professionnels assistés par l'IA.",
    aiTitle: "Intelligence Artificielle",
    aiSubtitle: "au Service de la Justice",
    mainDesc: "Legea Aplicată n'est pas qu'un simple logiciel législatif. C'est un écosystème complet intégrant la législation, la doctrine et la jurisprudence à la puissance d'analyse de l'Intelligence Artificielle.",
    founderTitle: "Fondateur de LegeaAplicata.ro",
    founderQuote: "\"La justice moderne requiert une compréhension profonde de deux mondes : la rigueur de la loi et la précision de la technologie.\"",
    expertTitle: "Formation Juridique",
    expertDesc: "Études en sciences juridiques appliquées au développement d'architectures d'indexation, de classification et de recherche d'informations législatives.",
    softwareTitle: "Génie Logiciel",
    softwareDesc: "Compétences informatiques avancées appliquées à la numérisation et à la rationalisation des processus juridiques.",
    whyUs: "Pourquoi LegeaAplicata.ro ?",
    legalIntelTitle: "Legal Intelligence",
    legalIntelDesc: "Nous combinons l'analyse de données publiques avec des algorithmes de recherche pour faciliter l'accès rapide aux décisions, lois et repères doctrinaux.",
    trustTitle: "Professionnalisme et Confiance",
    trustDesc: "Chaque fonctionnalité de la plateforme est conçue pour la recherche et la documentation, sans fournir de consultation juridique et sans remplacer un avocat autorisé.",
    founderMission: "\"Notre mission est de faciliter la documentation juridique par la technologie. LegeaAplicata.ro est une plateforme logicielle de recherche informationnelle dédiée à un accès efficace aux données.\"",
    roadmapTitle: "Feuille de Route de l'Innovation",
    evolutionTitle: "Évolution Continue",
    evolutionDesc: "Un engagement ferme envers la performance : nous lançons constamment de nouvelles fonctionnalités qui transforment votre façon de travailler.",
    watchVideo: "Voir la Présentation",
    videoError: "Votre navigateur ne prend pas en charge la lecture de vidéos HTML5.",
    videoUrl: "/assets/prezentare/timeline_video_full.mp4",
    videoMobileUrl: "/assets/prezentare/timeline_mobile_full.mp4",
    contactMe: "Contactez-moi",
    readyForFuture: "Prêt pour l'avenir ?",
    tryFreeToday: "Commencez gratuitement aujourd'hui",
    timeline: {
      perspective: {
        title: "Perspectives Juridiques",
        description: "Extrait automatiquement et structure les arguments de la cour, l'analyse judiciaire et la doctrine applicable à partir de milliers de décisions de justice. Comprend un filtrage instantané par domaine juridique et objet sémantique.",
        date: "21 Février 2026"
      },
      a: {
        title: "Écosystème Juridique Intégré",
        description: "Une plateforme unifiée qui modernise la recherche jurisprudentielle, mettant la technologie au service d'une documentation rapide et structurée.",
        date: "10 Janvier 2026"
      },
      b: {
        title: "Bibliothèque Juridique Numérique",
        description: "Accès gratuit et instantané à la législation mise à jour et à une vaste bibliothèque de modèles de documents. Utilisez notre moteur de recherche sémantique pour trouver le formulaire ou la loi exacte en quelques secondes.",
        date: "15 Décembre 2025"
      },
      c: {
        title: "Vaste Bibliothèque de Modèles Validés",
        description: "Accédez à des centaines de modèles d'actes de procédure prêts à l'emploi, validés d'un point de vue procédural.",
        date: "28 Novembre 2025"
      },
      d: {
        title: "Modèles Standardisés et Mis à Jour",
        description: "Rédigez en toute confiance. Chaque modèle de document respecte rigoureusement les règles de procédure et les pratiques des tribunaux, avec une structure claire et un contenu juridiquement validé.",
        date: "12 Novembre 2025"
      },
      e: {
        title: "Tous les Codes en un Seul Endroit",
        description: "Naviguez sans effort à travers l'ensemble des codes statutaires de la Roumanie. Notre moteur affiche simultanément les articles pertinents du Code civil, du Code pénal ou des Codes de procédure, offrant une vue d'ensemble de toute institution juridique.",
        date: "25 Octobre 2025"
      },
      f: {
        title: "Doctrine et Commentaires",
        description: "Accédez directement aux extraits de doctrine et aux analyses associés à chaque article, économisant des heures de recherche manuelle.",
        date: "10 Octobre 2025"
      },
      g: {
        title: "Analyse Juridique Augmentée",
        description: "Obtenez un avantage stratégique. En combinant les explications générées par l'IA et l'accès à de réelles décisions de justice, construisez votre argumentation sur une base d'information solide et complète.",
        date: "22 Septembre 2025"
      },
      h: {
        title: "Analyse Instantanée de l'Exposé des Faits",
        description: "Saisissez les détails factuels complets de votre dossier. Le système analyse automatiquement le contexte (parties, objet, cause) et identifie rapidement les précédents judiciaires et les modèles de demandes applicables.",
        date: "5 Septembre 2025"
      },
      i: {
        title: "Préparation et Auto-évaluation",
        description: "Transformez l'étude de la jurisprudence en entraînement actif. La plateforme peut générer automatiquement des QCM à partir des affaires identifiées, vous aidant à tester vos connaissances et à vous préparer efficacement aux examens.",
        date: "18 Août 2025"
      },
      j: {
        title: "Navigation en Profondeur",
        description: "Explorez chaque facette d'une décision. Utilisez le menu latéral intelligent pour accéder directement à la section qui vous intéresse : examinez l'exposé des faits, analysez la décision finale ou accédez aux modèles et codes associés.",
        date: "2 Août 2025"
      },
      k: {
        title: "Extraction Automatique de l'Exposé des Faits",
        description: "Comprenez l'histoire derrière le dossier. La plateforme sépare l'exposé des faits des arguments juridiques techniques, vous permettant de passer rapidement en revue l'historique du litige sans vous perdre dans les détails de la procédure.",
        date: "15 Juillet 2025"
      },
      l: {
        title: "Apprendre des Arguments de la Cour",
        description: "Perfectionnez votre stratégie. En analysant la manière dont le juge a validé ou rejeté les arguments des parties, construisez des défenses plus solides et anticipez mieux les réactions des tribunaux dans vos propres dossiers.",
        date: "28 Juin 2025"
      },
      m: {
        title: "Recherche dans le Texte de la Décision",
        description: "Ne perdez pas de temps à lire des dizaines de pages non pertinentes. Utilisez le moteur de recherche interne pour localiser instantanément des mots-clés, des noms ou des articles de loi directement dans le corps de la décision de justice.",
        date: "12 Juin 2025"
      },
      n: {
        title: "Leçons Juridiques Décryptées",
        description: "Allez au-delà de la simple décision pour comprendre le principe juridique sous-jacent. La section 'Que retient-on de cette affaire ?' extrait le cœur théorique de la décision, transformant chaque cas en une leçon de droit appliqué.",
        date: "25 Mai 2025"
      },
      o: {
        title: "Modèles Suggérés Contextuellement",
        description: "Ne cherchez plus une aiguille dans une botte de foin. La plateforme identifie la nature juridique de l'affaire et met automatiquement à votre disposition une liste de modèles de requêtes et d'actes de procédure parfaitement adaptés au litige.",
        date: "8 Mai 2025"
      },
      p: {
        title: "Lien Direct avec la Loi",
        description: "Plus de recherche manuelle d'articles. La plateforme jette un pont entre la jurisprudence et la législation, affichant automatiquement les dispositions légales applicables pour vous permettre de saisir rapidement la base légale de la décision.",
        date: "15 Avril 2025"
      },
      q: {
        title: "Calcul Automatique des Frais",
        description: "Éliminez l'incertitude liée aux coûts. Le système reconnaît le type de demande (ex: contestation de saisie) et pré-remplit le calculateur avec les paramètres appropriés, offrant instantanément une estimation précise des droits de timbre judiciaires.",
        date: "20 Mars 2025"
      },
      r: {
        title: "Prédiction et Stratégie IA",
        description: "Anticipez l'issue de votre dossier. Nos algorithmes analysent des milliers d'affaires similaires pour estimer vos chances de succès, la durée de la procédure et les arguments gagnants, transformant l'incertitude en stratégie calculée.",
        date: "10 Février 2025"
      },
      s: {
        title: "Votre Bibliothèque de Connaissances",
        description: "Plus qu'un simple outil, c'est une ressource de développement. Accédez à une vaste archive de plus de 1600 articles et analyses juridiques, faisant de la plateforme votre partenaire principal pour la recherche et le perfectionnement professionnel continu.",
        date: "15 Janvier 2025"
      },
      t: {
        title: "Recherche par Numéro de Dossier",
        description: "Démarrez directement depuis votre propre dossier. Saisissez le numéro d'enregistrement et la plateforme identifie automatiquement la matière et l'objet de l'affaire, générant instantanément une liste de précédents judiciaires similaires pertinents.",
        date: "21 Mai 2024"
      }
    }
  }
};

export default prezentareTranslations;
